<template>
    <el-dialog width="70%" title="PDF预览" :close-on-click-modal="false" :append-to-body="true" :visible.sync="visible">
        <el-row align="middle" justify="center">
            <el-col :span="12">
                <el-tag type="info">{{fileName}}</el-tag>
            </el-col>
            <el-col :span="6">
                <el-button size="small" plain @click.stop="prePage">上一页</el-button>
                <el-tag type="info">{{pageNum}}/{{pageTotalNum}}</el-tag>
                <el-button size="small" plain @click.stop="nextPage">下一页</el-button>
            </el-col>
            <el-col :span="6">
                <el-button type="primary" size="small" @click.stop="clock">顺时针旋转</el-button>
                <el-button type="primary" size="small" @click.stop="counterClock">逆时针旋转</el-button>
            </el-col>
        </el-row>
        <el-row align="middle" justify="center">
            <el-col :span="24">
                    <pdf ref="pdf" 
                    :src="url" 
                    :page="pageNum"
                    :rotate="pageRotate"  
                    @progress="loadedRatio = $event"
                    @page-loaded="pageLoaded($event)" 
                    @num-pages="pageTotalNum=$event" 
                    @error="pdfError($event)" 
                    @link-clicked="page = $event">
                    </pdf>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script>
    import pdf from 'vue-pdf'
    export default {
        components:{    
            pdf
        },
        data(){
            return {
                visible: false,
                url:"",
                fileName: "",
				pageNum: 1,
				pageTotalNum: 1,
				pageRotate: 0,
				// 加载进度
				loadedRatio: 0,
				curPageNum: 0,
            }
        },
        mounted() {
        },
        methods: {
            init(url, fileName) {
                debugger
                this.visible = true
                this.url = url
                this.fileName = fileName
            },
            // 上一页函数，
			prePage() {
				var page = this.pageNum
				page = page > 1 ? page - 1 : this.pageTotalNum
				this.pageNum = page
			},
            // 下一页函数
			nextPage() {
				var page = this.pageNum
				page = page < this.pageTotalNum ? page + 1 : 1
				this.pageNum = page
			},
            // 页面顺时针翻转90度。
			clock() {
				this.pageRotate += 90
			},
            // 页面逆时针翻转90度。
			counterClock() {
				this.pageRotate -= 90
			},
            // 页面加载回调函数，其中e为当前页数
			pageLoaded(e) {
				this.curPageNum = e
			},
            // 其他的一些回调函数。
			pdfError(error) {
				console.error(error)
			},
        }
    }
</script>
<style lang="scss">

</style>
